export default __webpack_public_path__ + "static/media/main_icon_negative.bbdebd4a.png";